export default __webpack_public_path__ + "static/media/hm-qs-img.940484da.webp";